<template>
    <div>
      <b-container class="m-0 p-0" fluid>
        <b-row>
          <b-col cols="12">
            <div class="schwrapper mt-2 p-4 pt-2">
              <span class="bcohe">Notifications <b-badge variant="danger" size="lg" class="ml-3">{{
                getNotiRead
              }} Unread</b-badge></span> <br />
                <b-skeleton-wrapper class="text-center mt-3" :loading="loading">
                  <template #loading>
                  <b-skeleton width="100%"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="90%"></b-skeleton>
                  <b-skeleton width="100%" class="mt-3"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="90%"></b-skeleton>
                  <b-skeleton width="100%" class="mt-3"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="100%"></b-skeleton>
                  <b-skeleton width="100%" class="mt-3"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="100%"></b-skeleton>
                  <b-skeleton width="100%" class="mt-3"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="90%"></b-skeleton>
                  <b-skeleton width="100%" class="mt-3"></b-skeleton>
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="100%"></b-skeleton>
  
                  </template>
              </b-skeleton-wrapper>
              <div v-if="!loading">
                <div v-for="(noti, index) in usenotifications" :key="index" class="noti-item-wrapper" @click="openNoti(noti)">
                    <div :class="{ 'font-weight-bold': getUserRead(index) }" class="noti-title">
                        {{ noti.title }}
                    </div>

                    <div :class="{
                        'font-weight-bold': getUserRead(index),
                        'font-weight-lighter': !getUserRead(index)
                      }" class="font-italic">
                        {{  shortenBody(noti.body) }}
                    </div>
                </div>
              </div>
              <div class="text-center vmore">
                <b-row>
                    <b-col class="text-left p-0 m-0">
                        <p>Showing {{ ((intervalnum2 * pages2) - intervalnum2) + 1 }} - {{ endnum2 > endssup ? endssup : endnum2 }}</p>
                    </b-col>
                    <b-col class="text-right p-0 m-0 button-pager-group">
                        <b-button-group size="xs">
                            <b-button v-for="(page, index) in ranger2" :key="index" :page="page" :class="[ pages2 == page ? 'active-page-btn' : '']" @click="newPage2(page)" class="ml-1 page-buttons" size="xs" variant="outline-dark">{{ page }}</b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from "vuex";
  // import store from "@/store"
  
  export default {
    components: {
    },
    data() {
      return {
        bo: "",
        limitnum2: this.endss,
        intervalnum2: 10,
        endnum2: 10,
        pages : 1,
        pages2 : 1,
        btnrange2 : this.endss,
        startnum2 : 0,
        scheduleadded: false,
        scheduling: false,
        cheked: "WE are testing",
        callink : "",
        org : "Quicktest",
        structure: "",
        sameName : "",
        loading : false
      };
    },

    // beforeRouteEnter (to, from, next) {
    //     store.dispatch("dashboard/fetchNotifications");
    //     next();
    // },
    
    mounted(){
      this.fetchData();
    },
  
    methods: {
      ...mapActions("dashboard", ["fetchNotifications"]),
      async fetchData() {
        this.loading = true;
        try {
          await this.fetchNotifications();
          this.loading = false;
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      },
      getUserRead(index) {
            let noti = this.notifications[index];

            return noti.users_read.includes(this.details.trackid) ? false : true;
        },
        shortenBody(body) {
            let formatedBody = body.replace(/(<([^>]+)>)/gi, "");
            let newBody = formatedBody.slice(0, 250) + "...Read more";

            return newBody;
        },
        openNoti(noti) {
            this.updateNotiReaders(noti)
            this.$router.push({
                name: "view-notification",
                params: {
                    id: noti.id
                }
            });
        },
        async updateNotiReaders(noti){
            let payload = {
                user_id : this.details.trackid,
                noti_id : noti.id
            }

            await this.setNotiReaders(payload).then(() => {
                this.$store.dispatch("dashboard/fetchNotifications");
            })
        },
  
      
      stopschedule() {
        this.scheduling = false
      },
      newPage2(page){
        this.pages2 = page
        let newend = this.intervalnum2 * page;

        if (newend < this.endssup) {
            this.endnum2 = newend;
            this.startnum2 = newend - this.intervalnum2 ;
        } else {
            this.endnum2 = this.endssup;
            this.startnum2 = newend - this.intervalnum2;
        }

    },
      ...mapActions("dashboard", ["setNotiReaders"]),
    },
    computed: {
      ...mapState({
        plan: (state) => state.loginmaster.details.plan,
        details : (state) => state.loginmaster.details,
        premium: (state) => state.loginmaster.details.premium_details,
        notifications : (state) => state.dashboard.notifications,
        allinsti: (state) => state.exam.allinstitutions,
        Categories: state => state.exam.allcategories,
        environ : (state) => state.loginmaster.environ,
        origin : (state) => state.loginmaster.site_origin
      }),
    
      usenotifications() {
        return this.notifications.slice(this.startnum, this.endnum);
      },
      endssup() {
        let end = this.notifications.length;
        return end;
        },
        ranger2(){
            let ranger = Math.ceil(this.notifications.length/this.intervalnum2)
            return ranger
        },
        getNotiRead() {
            let noti = this.notifications.map(x => x.users_read);
            let unread =
                this.notifications.length -
                noti.filter(x => x.includes(this.details.trackid)).length;
            return unread;
        }
    },
  };
  </script>
  
  <style scoped>
  .schwrapper {
    background-color: white;
    border-radius: 20px 20px;
    /* min-height: 70vh; */
  }
  
  .bcohe {
    font-size: 1.5rem;
    font-weight: bold;
  }
  
  .viewmore {
    background-color: rgb(241, 234, 234);
    border-radius: 100px;
    width: 50px;
    height: 50px;
    margin: 0px auto;
    box-shadow: 5px 5px 15px black;
    cursor: pointer;
  }
  
  .vmore {
    margin: 5px;
    padding: 10px;
  }
  
  .scohe {
    font-size: 1.2rem;
  }
  
  .twrap {
    background-color: white;
    border-radius: 20px 20px;
    min-height: 30vh;
  }
  
  .addbtn {
    border-radius: 30px 30px;
    background-color: #00377b;
    font-size: 1.2rem;
    font-weight: bold;
    box-shadow: 1px 1px 8px black;
  }
  
  .btn-add {
    background-color: #00377b;
    font-size: 1.3rem;
    font-weight: bolder;
  }
  
  .btn-add:hover {
    background-color: rgba(24, 24, 214, 0.721);
  }
  .lba{
    display: inline-block;
    background-color:#00984a;
    color: white;
    width: 200px;
    font-size: 1.2rem;
    font-weight: bold;
    text-decoration: none;
    border-radius: 10px 10px;
    cursor: pointer;
  }
  .lba:hover{
    text-decoration: none;
  }
  .vmore {
      margin: 5px;
      padding: 10px;
  }
  
  .page-buttons{
      width: 35px;
      height: 35px;
  }
  .active-page-btn{
      background-color: #00377b;
      color: white;
  }
  
  .v-button{
    border-radius : 10px 10px;
    width: 10rem;
    height: 3rem;
    background-color : #00984a;
    font-weight : bolder;
    color: white;
    position: relative;
    bottom: -80%;
    border : 0px;
    font-size: 18px;
  }
  .v-button:hover{
      background-color: white;
      color: #00984a;
      border : 1px solid #00984a; 
  }
  .button-pager-group{
      overflow-x:auto;
      scroll-behavior: smooth;
      scrollbar-width: thin;
  }

  .noti-item-wrapper {
    border-radius: 10px 10px;
    background-color: rgba(250, 249, 249, 0.927);
    padding: 10px;
    margin-top: 10px;
    cursor: pointer
}

.noti-item-wrapper:hover{
    background-color: rgba(247, 247, 247, 0.927);
}

.noti-title{
    font-size: 20px;
}

.noti-body{

}
  
  @media screen and (max-width: 999px) {
      .page-buttons{
          width: 25px;
          height: 25px;
          padding: 0px 0px 0px 5px ;
      }
      .v-button{
          width:fit-content;
          height: 2.5rem;
      }
  }
  
  @media (min-width: 768px) {
    .adhlg {
      display: none;
    }
  }
  </style>
  